export default __webpack_public_path__ + "static/media/Girl_with_laptop.7ffc4664.webp";